import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Link import kiya gaya
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactPage = () => {
    return (
        <div className="bg-gray-50 min-h-screen">
            <Navbar />

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="relative h-[350px] w-full bg-cover bg-center flex items-center justify-center text-white" style={{ backgroundImage: "url('/about-banner.jpg')" }}>
                <div className="absolute inset-0 bg-black/50" />
                <h1 className="relative text-5xl font-bold z-10">Contact Us</h1>
            </motion.div>

            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="space-y-8">
                    <h2 className="text-3xl font-bold text-[#1a2b4d]">Get In Touch</h2>
                    <div className="space-y-4 text-gray-700">
                        <p className="flex items-center gap-4"><FaPhone className="text-[#f15a24]" /> +91 9999320112</p>
                        <p className="flex items-center gap-4"><FaEnvelope className="text-[#f15a24]" /> rajkurumaenterprises@gmail.com</p>
                        <p className="flex items-start gap-4"><FaMapMarkerAlt className="text-[#f15a24] mt-1" /> 375/18, 1st Floor, Civil Lines, Gurugram, Haryana 122001</p>
                    </div>

                    {/* Enquiry Button Add Kiya */}
                    <div className="mt-8">
                        <Link to="/enquiry">
                            <button className="bg-[#f15a24] text-white px-8 py-3 rounded font-bold hover:bg-[#d44d1e] transition uppercase tracking-wider">
                                Enquire Now
                            </button>
                        </Link>
                    </div>

                    <div style={{ width: '100%', height: '350px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #ddd', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <iframe
                            title="Location Map"
                            width="100%" height="100%" frameBorder="0" style={{ border: 0 }}
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.1396264669866!2d77.03052598492082!3d28.449648892483863!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d199b6105c2b3%3A0x16c9fbb03ccf9df3!2sRajkuruma%20Enterprises%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1721132400000!5m2!1sen!2sin"
                            allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ContactPage;